<template>
  <div
    :value="value"
    @input="$emit('input', modelvalue)"
    class="number-controller" :style="{ width: width + 'px' }">
    <div class="number-container">
      <el-button :disabled="modelvalue === min" class="number-button" @click="onChangeMinus">
        <i class="el-icon-minus" />
      </el-button>
      <div class="number-display">
        {{ modelvalue }}
      </div>
      <el-button :disabled="modelvalue === max" class="number-button" @click="onChangePlus">
        <i class="el-icon-plus" />
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'number-input',
  props: [
    'value',
    'min',
    'max',
    'step',
    'width',
    'quantity'
  ],
  watch: {
    quantity () {
      this.modelvalue = this.quantity
      this.count = Math.ceil(this.quantity / this.min)
      if (this.modelvalue > this.max) {
        this.modelvalue = this.max
        this.$emit('update:quantity', this.modelvalue)
      }
    }
  },
  data () {
    return {
      previousQty: this.quantity,
      count: 1,
      modelvalue: this.quantity
    }
  },
  mounted () {
    // console.log('quantity', this.quantity)
    // console.log('min', this.min)
    this.count = Math.ceil(this.quantity / this.min)
    this.count = this.count ? this.count : 1
    if (this.modelvalue > this.max) {
      this.modelvalue = this.max
      this.$emit('update:quantity', this.modelvalue)
    }
  },
  methods: {
    onChangeMinus () {
      if (this.modelvalue > this.min) {
        this.count--
        this.modelvalue = this.count * this.min
        this.modelvalue = this.modelvalue < this.min ? this.min : this.modelvalue
        this.$emit('update:quantity', this.modelvalue)
        this.$emit('change', this.modelvalue)
      }
    },
    onChangePlus () {
      if (this.modelvalue < this.max) {
        // console.log('max', this.max)
        // console.log('modelvalue', this.modelvalue)
        // console.log('count', this.count)
        this.count++
        this.modelvalue = this.count * this.min
        this.modelvalue = this.modelvalue > this.max ? this.max : this.modelvalue
        this.$emit('update:quantity', this.modelvalue)
        this.$emit('change', this.modelvalue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../styles/settings.scss";

.number-controller {
  display: flex;
  height: 100%;
  .number-container {
    display: flex;
    width: 100%;
    min-height: 100%;
    border: 1px solid #ddd;
    & > .number-button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #ddd;
      color: $black-color;
      width: 20%;
      border-radius: 0;
      border: 0;
    }
    & > .number-display {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      font-size: 16px;
      background-color: $white-color;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NumberInput.vue